import { __assign, __rest } from "tslib";
import * as React from 'react';
export var ToggleSwitch = function (_a) {
    var onChange = _a.onChange, error = _a.error, label = _a.label, progress = _a.progress, children = _a.children, props = __rest(_a, ["onChange", "error", "label", "progress", "children"]);
    var inputClass = "form-control".concat(error ? ' error' : '');
    var sliderClass = "slider".concat(progress ? ' progress' : '');
    var change = React.useCallback(function (e) { return onChange === null || onChange === void 0 ? void 0 : onChange(e.target.checked); }, [onChange]);
    return (React.createElement("div", { className: "form-group" },
        React.createElement("label", { className: "checked-container", disabled: props.disabled },
            React.createElement("input", __assign({}, props, { type: "checkbox", readOnly: progress, className: inputClass, onChange: change })),
            React.createElement("span", { className: sliderClass }),
            label && React.createElement("span", { className: "label" }, label)),
        children));
};
//# sourceMappingURL=index.js.map